import { Link } from "react-router-dom";
import { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    const form = e.currentTarget;
    const data = new URLSearchParams();
    data.append("email", email);
    try {
      await fetch("https://readdy.ai/api/form/d7fqc4aa509fjl5l0ijg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
    } catch {
      // silent
    }
    setSubmitted(true);
    setEmail("");
    form.reset();
  };

  return (
    <footer className="bg-[#f5f3ee] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Top Row */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-10 pb-12 border-b border-[#ddd]">
          {/* Brand */}
          <div className="max-w-xs">
            <div className="mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/15616acb-dd20-42a3-bb13-24e14d98a32e/707ceb8d-a118-467e-a1f1-a92ec3214991_SED-Logo.png?v=25b700dde891a260d3a0501eba34a289"
                alt="SE Distribution"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-xs text-gray-500 mb-1">Registration: 202001036939 (1393260-U)</p>
            <p className="text-sm text-gray-500 leading-relaxed">
              Unit 21-11, Menara 1MK Kompleks, Mont Kiara, 50480 Kuala Lumpur
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1a1a1a]/10 text-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1a1a1a]/10 text-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1a1a1a]/10 text-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white transition-colors cursor-pointer">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <h4 className="font-semibold text-[#1a1a1a] text-sm mb-3">
                <Link to="/solutions">Solutions</Link>
              </h4>
              <ul className="space-y-2 text-sm text-gray-500">
                <li><Link to="/solutions/surveillance" className="hover:text-[#1a1a1a] transition-colors">Surveillance &amp; Security</Link></li>
                <li><Link to="/solutions/rugged-computing" className="hover:text-[#1a1a1a] transition-colors">Rugged Computing</Link></li>
                <li><Link to="/solutions/data-protection" className="hover:text-[#1a1a1a] transition-colors">HCI &amp; Storage</Link></li>
                <li><Link to="/vmware-alternative-malaysia" className="hover:text-[#1a1a1a] transition-colors">VMware Alternative</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-[#1a1a1a] text-sm mb-3">Product Spotlights</h4>
              <ul className="space-y-2 text-sm text-gray-500">
                <li><Link to="/hytera-bwv" className="hover:text-[#1a1a1a] transition-colors">Hytera BWC</Link></li>
                <li><Link to="/arcfra-spotlight" className="hover:text-[#1a1a1a] transition-colors">Arcfra HCI</Link></li>
                <li><Link to="/exagrid-spotlight" className="hover:text-[#1a1a1a] transition-colors">ExaGrid Backup</Link></li>
                <li><Link to="/exagrid-backup-malaysia" className="hover:text-[#1a1a1a] transition-colors">ExaGrid Backup Malaysia</Link></li>
                <li><Link to="/rugged-spotlight" className="hover:text-[#1a1a1a] transition-colors">Rugged Devices</Link></li>
                <li><Link to="/body-worn-camera-malaysia" className="hover:text-[#1a1a1a] transition-colors">Body-Worn Camera</Link></li>
                <li><Link to="/rugged-tablet-malaysia" className="hover:text-[#1a1a1a] transition-colors">Rugged Tablets</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-[#1a1a1a] text-sm mb-3">
                <Link to="/brands">Company</Link>
              </h4>
              <ul className="space-y-2 text-sm text-gray-500">
                <li><Link to="/about" className="hover:text-[#1a1a1a] transition-colors">About Us</Link></li>
                <li><Link to="/brands" className="hover:text-[#1a1a1a] transition-colors">Technology Partners</Link></li>
                <li><Link to="/case-studies" className="hover:text-[#1a1a1a] transition-colors">Case Studies</Link></li>
                <li><Link to="/industries" className="hover:text-[#1a1a1a] transition-colors">Industries</Link></li>
                <li><Link to="/arcfra-assessment" className="hover:text-[#1a1a1a] transition-colors">Free Assessment</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-[#1a1a1a] text-sm mb-3">
                <Link to="/contact">Contact</Link>
              </h4>
              <ul className="space-y-2 text-sm text-gray-500">
                <li><Link to="/contact" className="hover:text-[#1a1a1a] transition-colors">Contact Us Now</Link></li>
                <li><Link to="/contact" className="hover:text-[#1a1a1a] transition-colors">Get a Quote</Link></li>
                <li><a href="mailto:sales@sedistribution.com.my" className="hover:text-[#1a1a1a] transition-colors">sales@sedistribution.com.my</a></li>
                <li><a href="tel:+60364127917" className="hover:text-[#1a1a1a] transition-colors">+603 6412 7917</a></li>
              </ul>
            </div>
          </div>

          {/* Newsletter */}
          <div className="max-w-xs w-full">
            <p className="text-sm font-semibold text-[#1a1a1a] mb-1">Stay up to date</p>
            <p className="text-sm text-gray-500 mb-3">Get the latest product news and solution updates.</p>
            {submitted ? (
              <p className="text-sm text-green-700 font-medium">Thanks for subscribing!</p>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="flex-1 text-sm border border-gray-300 rounded-md px-3 py-2 outline-none focus:border-[#1a1a1a] bg-white"
                  required
                />
                <button
                  type="submit"
                  className="bg-[#1a1a1a] text-white text-sm px-4 py-2 rounded-md hover:bg-[#333] transition-colors whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-6 text-xs text-gray-400">
          <p>&copy; 2026 SE Distribution Sdn Bhd (1393260-U). All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="hover:text-[#1a1a1a] transition-colors">Privacy Policy</a>
            <a href="#" rel="nofollow" className="hover:text-[#1a1a1a] transition-colors">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
